export default __webpack_public_path__ + "static/media/global-footprint-Header-Mobile.a6b8da48.jpg";